import * as React from 'react';

// Constants
import { ROUTE_PATHS } from '../../constants/routes';

// Types
import { IUserNetwork } from '../../store/MeStore';
import { INetwork } from '../../store/NetworkStore';
import { INavigate } from './NetworksDialog';

// Components
import { FancyAvatar } from '../../components/Avatar';
import Box from '../../components/Box';
import Button from '../../components/Button';
import Divider from '../../components/Divider';
import Icon from '../../components/Icon';
import IconButton from '../../components/IconButton';
import List, {
  ListLinkItem,
  ListItemAvatar,
  ListItemText,
  ListItemIcon
} from '../../components/List';
import Toolbar from '../../components/Toolbar';
import Typography from '../../components/Typography';

// Component
interface IProps {
  network?: INetwork | null;
  networks: IUserNetwork[];
  navigate: INavigate;
  closeDialog: () => void;
}

function NetworksDialogSelector(props: IProps) {
  const currentNetworkId: string | null = props.network
    ? props.network.networkId
    : null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Toolbar>
        <Typography type="title" color="inherit" style={{ flexGrow: 1 }}>
          Networks
        </Typography>
        <span style={{ flexGrow: 1 }} />
        <IconButton onClick={props.closeDialog} aria-label="Close">
          <Icon>close</Icon>
        </IconButton>
      </Toolbar>
      <Divider />
      {props.networks.length > 0 ? (
        <List style={{ flexGrow: 1, overflowY: 'auto' }}>
          {props.networks.map(item => (
            <ListLinkItem
              key={item.networkId}
              routeName={ROUTE_PATHS.APP_NETWORK}
              routeParams={{ networkId: item.networkId }}
              onClick={props.closeDialog}
            >
              <ListItemAvatar>
                <FancyAvatar text={item.name} src={item.photoUrl} />
              </ListItemAvatar>
              <ListItemText primary={item.name} />
              {item.networkId === currentNetworkId ? (
                <ListItemIcon>
                  <Icon>check</Icon>
                </ListItemIcon>
              ) : null}
              {/*<ListItemSecondaryAction>
                                            <IconButton aria-label="Delete">
                                            <Icon>settings</Icon>
                                            </IconButton>
                                            </ListItemSecondaryAction>*/}
            </ListLinkItem>
          ))}
        </List>
      ) : (
        <Box pa={5} align="center">
          <Typography type="headline">You have no networks</Typography>
          <Typography type="subheading">
            Create or join a network to proceed.
          </Typography>
        </Box>
      )}

      <Divider />
      <div className={'App__NetworksDialog__bottom-bar'}>
        <Button onClick={() => props.navigate('CREATE')}>Create Network</Button>
        <Button onClick={() => props.navigate('JOIN')}>Join Network</Button>
      </div>
    </div>
  );
}

export default NetworksDialogSelector;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/NetworksDialogSelector.tsx